<template>
  <div>
    <Modal :title="title" v-model="visible" width="800" class="my-modal top add-user-wrap" :mask-closable="false" :footer-hide="true">
      <Form ref="form" :model="formData" class="page-form less" :label-width="75">
        <FormItem prop="name" label="姓名" :rules="$units.formRule.required('请输入', 'blur')">
          <Input v-model="formData.name" placeholder="请输入" />
        </FormItem>
        <!-- 掩码手机号 -->
        <FormItem prop="signNamePinyin" label="英文拼音（签单用）" :label-width="155" :rules="signNamePinyinRule">
          <Input v-model="formData.signNamePinyin" maxlength="30" placeholder="请输入英文拼音（签单用），最多30字符"
            @on-change="onSigningPinyinEdited" @on-blur="normalizeSigningPinyin" />
        </FormItem>
        <FormItem prop="mobile" label="手机号" key="mobile1" v-if="formData.id && oldMobile && !formData.mobileEyeShow">
          <span @dblclick="openEye(formData, 'mobile')">{{ formData.mobile }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'mobile')"></i>
          </a>
        </FormItem>
        <FormItem v-else prop="mobile" label="手机号" key="mobile2" :rules="$units.formRule.tel('请输入正确的手机号', true)">
          <Input v-model="formData.mobile" placeholder="请输入" />
        </FormItem>
        <!-- 掩码账号 -->
        <FormItem prop="account" label="登录账号" key="account1" v-if="formData.id && formData.account && !formData.accountEyeShow">
          <span @dblclick="openEye(formData, 'account')">{{ formData.account }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'account')"></i>
          </a>
        </FormItem>
        <FormItem
          prop="account"
          label="登录账号"
          key="account2"
          v-else
          :rules="[$units.formRule.required('请输入'), $units.formRule.str('不能含有特殊字符和标点符号'), forbidPureDigitsRule]"
        >
          <Input v-model="formData.account" placeholder="请输入" maxlength="20" />
        </FormItem>
        <FormItem v-if="!formData.id" prop="password" label="登录密码" :rules="$units.formRule.required('请输入', 'blur')">
          <Input v-model="formData.password" placeholder="请输入" type="password" />
        </FormItem>
        <FormItem v-if="!formData.id" prop="password1" label="确认密码" :rules="$units.formRule.required('请输入', 'blur')">
          <Input v-model="formData.password1" placeholder="请输入" type="password" />
          <div class="info-text">密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号</div>
        </FormItem>
        <FormItem prop="status" label="状态">
          <i-switch v-model="formData.status" :disabled="disabled" size="large" true-value="1" false-value="0">
            <span slot="open">启用</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
        <FormItem v-if="formData.id" label="登录密码">
          <Button type="primary" @click="$emit('editPassword', { id: formData.id })">修改密码</Button>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="loading">确认</Button>
      </div>
    </Modal>
    <!-- 解密组件 -->
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>
  
<script>
import { common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import validUserName from '@/components/commons/validUserName';
import { signNamePinyinFormMixin, isValidSignNamePinyin } from '@/api/signNamePinyin';
export default {
  mixins: [common, signNamePinyinFormMixin],
  components: { 
    selectTree,
    validUserName
  },
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      userInfo: {},
      oldMobile: '',
      formData: {
        type: '3', //账号类型1-业务员2-机构管理员3-转介人管理员
        status: '1',
        mobile: '',
        name: '',
        signNamePinyin: '',
        account: '',
        password: '',
        password1: ''
      },
      forbidPureDigitsRule: {
        validator: (rule, value, callback) => {
          if (value) {
            // 限制字符串长度不小于6位
            if (value.length < 6) {
              callback(new Error('长度不能小于6位'));
            // } else if (/^[0-9]*$/.test(value)) {
            //   callback(new Error('不能为纯数字'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        }
      }
    };
  },
  watch: {},
  computed: {
    disabled() {
      return this.formData.id == this.userInfo.userid;
    },
    title() {
      return this.formData.id ? '编辑账号' : '新增账号';
    }
  },
  created() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    strLength() {
      return {
        userInfo: '',
        required: true,
        message: '请输入正确的护照号',
        trigger: 'change',
        validator(rule, value) {
          if (value.length != 8 && value.length != 9) {
            return false;
          }
          return true;
        }
      };
    },
    save() {
      this.normalizeSigningPinyin();
      if (!isValidSignNamePinyin(this.formData.signNamePinyin)) return this.$notice.error('英文拼音（签单用）必填，最多30个字符');
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        // 校验密码
        if (!formData.id) {
          if (formData.password != formData.password1) {
            return this.$notice.error('密码输入不一致');
          }
          if (!this.verification(formData.password)) {
            return;
          }
        }
        // 校验账号
        const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");
        // 新增或者解密后校验
        if ((!formData.id || formData.accountEyeShow) && regTeShu.test(formData.account)) {
          return this.$notice.error('登录账号支持输入数字、字母和汉字');
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        if(formData.password) {
          const now = this.$units.formatDate(new Date(), 'yyyyMMdd');
          formData.password = this.$units.sm4Encrypt(formData.password, now + now);
        }
        delete formData.password1;
        this.$http({
          type: 'POST',
          url: formData.id ? '/buz/userBase/edit' : '/buz/userBase/add',
          data: formData
        })
          .then(res => {
            this.visible = false;
            this.loading = false;
            this.$emit('success');
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      });
    },
    getDetail() {
      this.$http({
        type: 'GET',
        url: '/buz/userBase/read/detail',
        data: { id: this.formData.id }
      }).then(res => {
        this.formData = res.data;
        this.prepareSigningPinyin();
        this.oldMobile = this.formData.mobile;
      });
    },
    open(data) {
      this.signNamePinyinAutoValue = '';
      console.log('data', data);
      this.loading = false;
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));

      this.visible = true;
      data = JSON.parse(JSON.stringify(data));
      if (data.id) {
        this.formData.id = data.id;
        this.getDetail();
      } else {
        this.formData = {
          type: '3', //账号类型1-业务员2-机构管理员3-转介人管理员
          status: '1',
          mobile: '',
          name: '',
          signNamePinyin: '',
          account: '',
          password: '',
          password1: ''
        };
        this.$refs.form && this.$refs.form.resetFields();
      }
      this.formData.orgId = this.userInfo.organId;
    },
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error('密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号'); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    },
    // 解密
    openEye(row, key) {
      if (!row['validName' + key]) {
        this.$refs.validUserNameRef.open(row, key);
        return;
      }
      if (!row[key + 'EyeShow']) {
        const map = {
          account: 0,
          mobile: 2,
          idNo: 1
        };
        this.descrypt(
          {
            query: row.id,
            operationFunction: 1,
            operationType: map[key]
          },
          row,
          key
        ).then(() => {
          this.$set(row, key + 'EyeShow', true);
        });
      } else {
        this.$set(row, key + 'EyeShow', false);
      }
    }
  }
};
</script>
  <style lang="scss" scoped>
.add-user-wrap {
  h2 {
    font-weight: 700;
    margin-bottom: 10px;
  }
  .info-text {
    font-size: 12px;
    color: #a8adb7;
    margin-left: -62px;
    margin-top: 20px;
    float: left;
  }
  .full {
    width: 100%;
  }
}
</style>
